import { atom } from "jotai";
import { ICohortComment } from "../base";

const INITIAL_COMMENTS: ICohortComment[] = [];

export const cohortCommentsAtom = atom(INITIAL_COMMENTS);
